
import shareCountFactory from 'react-share/es/utils/shareCountFactory';

function getFacebookShareCount(shareUrl, callback) {
    const endpoint = "https://graph.facebook.com/?id="+shareUrl+"&fields=og_object{engagement}&locale=es";

    $.ajax({
        //Cambiar a type: POST si necesario
        type: "GET",
        //Datos que se envian
        // Formato de datos que se espera en la respuesta
        dataType: "json",
        // URL a la que se enviará la solicitud Ajax
        url: endpoint,
    })
        .done(function( data, _textStatus, _jqXHR ) {
            //console.log(data);
            callback(data && data.og_object && data.og_object.engagement ? data.og_object.engagement : undefined);
        })
        .fail(function( {responseText, status}, _textStatus, _errorThrown ) {
            // if ( console && console.log ) {
            //     console.log( "Not count : " +  responseText);
            // }
            callback(undefined);
        });

}

export default shareCountFactory(getFacebookShareCount);